import {VoteEnum} from '../types';

export function getVoteType(vote: string): VoteEnum {
  switch (vote) {
    case 'yes':
      return 'yes';
    case 'abstain':
      return 'abstain';
    case 'no':
      return 'no';
    default:
      throw new Error(`Unknown vote type: ${vote}`);
  }
}
